import React, { useState, useEffect } from "react";
import QuantitySelector from "../components/body/QuantitySelector";
import Container from "react-bootstrap/Container";
import { Button, Spinner } from "react-bootstrap";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import api from "../api/api";
const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const userData = JSON.parse(localStorage.getItem("user"));
  const accessToken = userData?.token;

  const fetchCartData = async () => {
    try {
      const cartRes = await api.get("/getcart", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const cartItems = cartRes.data?.items || [];

      if (cartItems.length === 0) {
        setCartItems([]);
        return;
      }

      const productPromises = cartItems.map((item) =>
        axios.get(
          `http://localhost:80/api/products/getdetailproduct/${item.productId}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
      );

      const productResponses = await Promise.all(productPromises);

      const detailedItems = productResponses.map((res, idx) => ({
        ...cartItems[idx],
        ...res.data.data,
      }));

      setCartItems(detailedItems);
    } catch (err) {
      console.error("Lỗi khi tải giỏ hàng:", err);
      setCartItems([]);
    }
  };

  const getCheckoutLink = async (orderId) => {
    try {
      const checkoutUrl = await api.get(`/orders/checkout/${orderId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log("Checkout URL:", checkoutUrl.data);
      if (checkoutUrl.data.checkoutUrl) {
        window.location.href = checkoutUrl.data.checkoutUrl;
      } else {
        setTimeout(() => {
          getCheckoutLink(orderId);
        }, 3000);
      }
    } catch (error) {
      console.error("Lỗi khi lấy link thanh toán:", error);
      setIsProcessing(false);
      throw error;
    }
  };

  const handleCreateOrder = async () => {
    try {
      setIsProcessing(true);
      const orederRes = await axios.get(
        "http://localhost:80/api/orders/creatoreder",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const id = orederRes.data.order._id;
      console.log("Order ID:", id);
      await getCheckoutLink(id);
    } catch (error) {
      console.error("Lỗi khi tạo đơn hàng:", error);
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    fetchCartData();
  }, []);

  return (
    <div className="my-5">
      {/* Loading Overlay */}
      {isProcessing && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spinner
            animation="border"
            variant="light"
            style={{ width: "4rem", height: "4rem" }}
          />
          <p className="text-white mt-3 fs-5">
            Đang tạo link thanh toán, vui lòng đợi...
          </p>
        </div>
      )}

      <Container>
        <div className="bg-white p-4 rounded d-flex w-100">
          {/* --- Cột bên trái: Danh sách sản phẩm --- */}
          <div style={{ minWidth: "70%" }}>
            <h3 className="fw-bold mb-4">Giỏ Hàng</h3>

            {cartItems.length === 0 ? (
              <p>Giỏ hàng trống.</p>
            ) : (
              cartItems.map((item) => {
                const priceAfterDiscount =
                  item.price - (item.price * item.discount) / 100;

                return (
                  <div
                    key={item._id}
                    className="d-flex border p-3 rounded my-3 position-relative"
                    style={{ maxWidth: "1000px" }}
                  >
                    {/* Ảnh sản phẩm */}
                    <div className="mx-3">
                      <img
                        className="ct-img"
                        src={item.imageUrl}
                        alt={item.name}
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "8px",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    {/* Thông tin sản phẩm */}
                    <div className="flex-grow-1">
                      <p className="fw-bold mb-1">{item.name}</p>
                      <p className="text-muted mb-1">
                        Giá gốc:{" "}
                        <span className="text-decoration-line-through">
                          {item.price.toLocaleString("vi-VN")}₫
                        </span>
                      </p>
                      <p className="text-danger mb-1">
                        Giảm {item.discount}% →{" "}
                        <span className="fw-bold">
                          {priceAfterDiscount.toLocaleString("vi-VN")}₫
                        </span>
                      </p>

                      <QuantitySelector
                        price={item.price}
                        discount={item.discount}
                        quantity={item.quantity}
                      />
                    </div>

                    {/* Nút xóa */}
                    <Button
                      variant="outline-danger"
                      className="position-absolute"
                      style={{ bottom: "10px", right: "10px" }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </div>
                );
              })
            )}
          </div>

          {/* --- Cột bên phải: Thanh toán --- */}
          <div className="w-100 mx-3">
            <p className="m-0 fw-bold mx-5 my-3">Thanh Toán</p>

            {/* Tổng tiền */}
            <div className="d-flex justify-content-between">
              <div>Tổng giá</div>
              <div>
                {cartItems
                  .reduce((acc, item) => acc + item.price * item.quantity, 0)
                  .toLocaleString("vi-VN")}
                ₫
              </div>
            </div>

            <div className="lw my-2"></div>

            {/* Tổng sau giảm giá */}
            <div className="d-flex justify-content-between">
              <div>Tổng giá trị phải thanh toán</div>
              <div className="fw-bold text-success">
                {cartItems
                  .reduce(
                    (acc, item) =>
                      acc +
                      (item.price - (item.price * item.discount) / 100) *
                        item.quantity,
                    0
                  )
                  .toLocaleString("vi-VN")}
                ₫
              </div>
            </div>

            <div className="text-center my-3">
              Quét mã thanh toán không cần nạp
            </div>

            <Button
              onClick={handleCreateOrder}
              disabled={isProcessing}
              style={{
                width: "100%",
                marginBottom: "15px",
                backgroundColor: "#005BAA",
              }}
            >
              {isProcessing ? (
                <>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="false"
                    className="me-2"
                  />
                  Đang xử lý...
                </>
              ) : (
                "Mua siêu tốc qua Mobile Banking"
              )}
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Cart;
